import { defineMessages } from 'react-intl';

export const msgs = defineMessages({
  communicateTitle: {
    id: 'pib_communicate',
  },
  immerseTitle: {
    id: 'pib_immerse',
  },
  learnTitle: {
    id: 'pib_learn',
  },
  communicateDescription: {
    id: 'pib_marketing_description',
  },
  communicateMarketingDescription: {
    id: 'pib_marketing_communicate',
  },
  immerseMarketingDescription: {
    id: 'pib_marketing_immerse',
  },
  learnMarketingDescription: {
    id: 'pib_marketing_learn',
  },
});

export const en_us = defineMessages({
  marketingSectionTitle: {
    id: 'pib_marketing_title_en',
  },
  ctaButton: {
    id: 'seo_marketing_message_horizontal_button_label_en',
  },
});

export const es = defineMessages({
  marketingSectionTitle: {
    id: 'pib_marketing_title_es',
  },
  ctaButton: {
    id: 'seo_marketing_message_horizontal_button_label_es',
  },
});
